function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */


import Base from './base';
import URI from 'urijs'; // @namespace Model

var RegistrationInfo = /*#__PURE__*/function (_Base) {
  _inheritsLoose(RegistrationInfo, _Base);

  function RegistrationInfo() {
    return _Base.apply(this, arguments) || this;
  }

  var _proto = RegistrationInfo.prototype;

  _proto.url = function url() {
    return URI('/api/users').segment(this.get('login')).segment('registration_info').toString();
  };

  _proto.participationCost = function participationCost() {
    return parseFloat(this.get('participation_cost'));
  };

  _proto.needsToPay = function needsToPay() {
    return this.participationCost() > 0;
  };

  _proto.isExistingParticipant = function isExistingParticipant() {
    return !!this.get('existing_participant');
  }
  /*
   * true if the presenter's account has self-registration enabled.
   * Will be true for nearly every account.
   */
  ;

  _proto.participantSelfRegistration = function participantSelfRegistration() {
    return !!this.get('participant_self_registration');
  };

  _proto.register = function register(params) {
    if (params == null) {
      params = {};
    }

    return this.save(params, {
      url: this.registerUrl()
    });
  };

  _proto.registerUrl = function registerUrl() {
    return URI('register').setQuery('email', this.get('login')).toString();
  };

  return RegistrationInfo;
}(Base);

export default RegistrationInfo;